import { render, staticRenderFns } from "./aHeader.vue?vue&type=template&id=a946ccb6&scoped=true"
import script from "./aHeader.vue?vue&type=script&lang=js"
export * from "./aHeader.vue?vue&type=script&lang=js"
import style0 from "./aHeader.vue?vue&type=style&index=0&id=a946ccb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a946ccb6",
  null
  
)

export default component.exports